import { useCallback, useEffect, useState } from 'react';
import { useProvider } from 'wagmi';
import { ethers } from 'ethers';
import { useErrorHandler } from 'react-error-boundary';
import { tokenContractAddress } from '@/lib/globals';
import OnlyBotsToken from '@/contracts/OnlyBotsToken.json';
import { isPositiveInt } from '@/lib/numbers';
import { WrappedError } from '@/lib/WrappedError';

export const useCollectionInfo = (): { totalSupply: number; isValidBot: (tokenId: string) => boolean } => {
    const [totalSupply, setTotalSupply] = useState<number>(0);
    const errorHandler = useErrorHandler();
    const provider = useProvider();

    const getTotalSupply = useCallback(async () => {
        try {
            const contract = new ethers.Contract(tokenContractAddress, OnlyBotsToken.abi, provider);
            const supply = await contract.totalSupply();
            setTotalSupply(supply.toNumber());
        } catch (e: any) {
            errorHandler(new WrappedError('Error in contract.totalSupply()', e));
        }
    }, [provider, errorHandler]);

    const isValidBot = useCallback(
        (token: string) => {
            if (isPositiveInt(token)) {
                const tokenId = parseInt(token, 10);
                return tokenId <= totalSupply;
            }
            return false;
        },
        [totalSupply]
    );

    useEffect(() => {
        void getTotalSupply();
    }, [getTotalSupply]);

    return {
        totalSupply,
        isValidBot,
    };
};
